import React, { useEffect, useState } from 'react';

import { Link, withRouter } from 'react-router-dom';

import Api from '../../../util/api';

import t, { partial } from '../../../util/translation/translation';

import DisplayCounter from '../../_uiComponents/DisplayCounter';
import useConfig from '../../../util/useConfig';
import { formatCurrencyNumber } from '../../../util/functions';

import ChartLineVariantIcon from 'mdi-react/ChartLineVariantIcon';
import PulseIcon from 'mdi-react/PulseIcon';
import AccountMultipleIcon from 'mdi-react/AccountMultipleIcon';
import HomeModernIcon from 'mdi-react/HomeModernIcon';

const d = partial('Deals');

const StatisticsOverview = ({ setLoading, startEndObject }) => {
  const config = useConfig();
  const [data, setData] = useState();
  const fetchDealsStatistics = async () => {
    setLoading(true);
    try {
      const response = await Api.companies.getDealStatistics({
        startDate: startEndObject.start,
        endDate: startEndObject.end,
      });
      setData(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDealsStatistics();
  }, [startEndObject]);
  return (
    <div className="my-2">
      <DisplayCounter
        id="sales"
        color="primary"
        title={d('totalBusinessValue')}
        text={d('generatedInNetwork')}
        value={`${formatCurrencyNumber(data?.turnover || 0)} ${config.currencyCaps}`}
        icon={<ChartLineVariantIcon style={{ width: 18 }} />}
      />

      <DisplayCounter
        id="leads"
        title={d('totalActivities')}
        text={d('acrossAllCompanies')}
        value={`${data?.dealsCount || 0}`}
        icon={<PulseIcon style={{ width: 18 }} />}
      />

      <DisplayCounter
        id="meetings"
        title={d('activeCompanies')}
        text={d('inNetwork')}
        value={`${data?.dealsWithUniqueCompanyId || 0}`}
        icon={<HomeModernIcon style={{ width: 18 }} />}
      />
      <DisplayCounter
        id="meetings"
        title={d('activeUsers')}
        text={d('contributingMembers')}
        value={`${data?.dealsWithUniqueEmployeeId || 0}`}
        icon={<AccountMultipleIcon style={{ width: 18 }} />}
      />
    </div>
  );
};

export default withRouter(StatisticsOverview);
